import { ReactNode } from 'react';
import { ChevronIcon } from '../../assets/icons';
import Button from '../../components/Button';

type TableHeaderProps<T> = {
    children?: ReactNode;
    withSort?: boolean;
    sortKey?: keyof T;
    setSort: (key: keyof T) => void;
};

const TableHeader = <T extends unknown>({
    children,
    withSort,
    sortKey,
    setSort,
}: TableHeaderProps<T>) => {
    return (
        <div className='table-header'>
            {children}
            {withSort && (
                <Button
                    className='sort-container'
                    onClick={sortKey ? () => setSort(sortKey) : undefined}
                >
                    <ChevronIcon />
                    <ChevronIcon />
                </Button>
            )}
        </div>
    );
};

export default TableHeader;
